/**
 * @generated SignedSource<<ce9917554df69d55c6c9281264464c5b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPublicProfileMedia_publicProfile$data = {
  readonly avatarImage: {
    readonly path: string | null;
  } | null;
  readonly heroImage: {
    readonly path: string | null;
  } | null;
  readonly username: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftPublicProfileEditableMedia_publicProfile">;
  readonly " $fragmentType": "NftPublicProfileMedia_publicProfile";
};
export type NftPublicProfileMedia_publicProfile$key = {
  readonly " $data"?: NftPublicProfileMedia_publicProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPublicProfileMedia_publicProfile">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "path",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPublicProfileMedia_publicProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "heroImage",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPublicProfileEditableMedia_publicProfile"
    }
  ],
  "type": "PublicProfile",
  "abstractKey": null
};
})();

(node as any).hash = "74565296e93f9a2803631c50745d0dd7";

export default node;
